var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJencioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1844,
    height: 509,
    viewBox: "0 0 1844 509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2440588487824"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1844,
    height: 509,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M573,58c-21,0-37,16-37,37,0,19,16,35,36,35s37-16,37-36A35.85,35.85,0,0,0,573,58Zm28,126v-7c0-20-12-34-30-34s-30,14-30,34V331c0,23-5,37-15,43l-12,8c-10,6-14,14-14,25,0,17,14,30,35,30,27,0,55-24,63-53,3-10,3-14,3-40V184Z",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    d: "M722,291l101-44c18-8,25-17,25-30,0-39-46-75-95-75-60,0-111,51-111,111,0,61,52,113,113,113,22,0,45-7,62-19,16-11,23-21,23-34,0-16-14-30-31-30-7,0-12,2-19,8-12,9-23,12-35,12C742,303,732,300,722,291Zm60-77-77,33a50.12,50.12,0,0,1,50-46C767,201,776,204,782,214Z",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M1018,324v7c0,20,12,33,30,33s30-13,30-33V249c0-24-4-45-13-59a99.819,99.819,0,0,0-85-48c-29,0-57,13-75,36-15,19-22,40-22,69v84c0,20,13,33,30,33,18,0,30-13,31-33V241c0-22,16-39,36-39a38.415,38.415,0,0,1,34,21c3,8,4,13,4,31Z",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": 3,
    d: "M1116,253c0,62,51,113,113,113,43,0,88-28,88-54,0-17-13-31-30-31-7,0-12,2-19,7-8,6-14,10-15,11a47.508,47.508,0,0,1-24,6,51.5,51.5,0,0,1,1-103c13,0,22,4,35,14,8,7,12,8,19,8,17,0,31-13,31-30,0-13-6-21-22-32-19-13-43-21-65-21C1167,141,1116,192,1116,253Z",
    fill: "#fcc603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4",
    "data-name": 4,
    d: "M1418,291l101-44c19-8,25-17,25-30,0-39-46-75-95-75-60,0-110,51-110,111,0,61,51,113,112,113,22,0,45-7,62-19,16-11,23-21,23-34,0-16-13-30-31-30-7,0-12,2-19,8-12,9-23,12-35,12C1438,303,1428,300,1418,291Zm60-77-77,33a50.12,50.12,0,0,1,50-46C1463,201,1472,204,1478,214Z",
    fill: "#fcc603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_5",
    "data-name": 5,
    d: "M1679,142c-63,0-113,50-113,114,0,60,51,110,113,110s113-51,113-112C1792,192,1742,142,1679,142Zm0,60c28,0,51,23,51,52,0,28-23,50-51,50s-51-22-51-49C1628,225,1650,202,1679,202Z",
    fill: "#fcc603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M669,403h59v16H708v50H689V419H669Z",
    fill: "#6b6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1-2",
    "data-name": 1,
    d: "M880,469V403h32a46.357,46.357,0,0,1,14,2c3,1,5,3,7,6a16.894,16.894,0,0,1,3,10,29.585,29.585,0,0,1-2,10q-3,4.5-6,6a48.752,48.752,0,0,1-7,3c2,1,4,2,5,2a13.8,13.8,0,0,1,3,4,13.8,13.8,0,0,0,3,4l9,19H919l-10-20a10.69,10.69,0,0,0-3-5c-2-1-3-2-5-2h-2v27Zm19-39h8a17.594,17.594,0,0,0,6-1c1,0,2-1,3-2,0-1,1-2,1-4a7.638,7.638,0,0,0-2-5c-1-1-4-2-7-2h-9Z",
    fill: "#6b6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2-2",
    "data-name": 2,
    d: "M1129,458h-22l-3,11h-19l23-66h21l23,66h-20Zm-4-14-7-24-6,24Z",
    fill: "#6b6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3-2",
    "data-name": 3,
    d: "M1302,403h29a52.124,52.124,0,0,1,14,2c3,2,6,4,8,7a36.966,36.966,0,0,1,5,11,50.666,50.666,0,0,1,2,13c0,7-1,12-3,16a20.749,20.749,0,0,1-6,10c-3,3-6,4-9,5-4,2-8,2-11,2h-29Zm20,15v36h4c4,0,7,0,9-1s3-3,4-5c1-3,1-6,1-12,0-7-1-12-3-14-2-3-6-4-11-4Z",
    fill: "#6b6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4-2",
    "data-name": 4,
    d: "M1513,403h52v14h-32v11h29v13h-29v13h33v15h-53Z",
    fill: "#6b6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_5-2",
    "data-name": 5,
    d: "M1716,447l19-1c0,3,1,6,2,7a9.1,9.1,0,0,0,8,4c3,0,5,0,7-2a6.021,6.021,0,0,0,0-9c-2-2-5-3-10-4-8-2-14-5-18-8a19.01,19.01,0,0,1-5-13c0-3,1-6,2-9a23.609,23.609,0,0,1,9-8,60.525,60.525,0,0,1,15-2c8,0,14,1,18,5,4,3,7,8,8,15l-18,1a48.752,48.752,0,0,0-3-7,14.453,14.453,0,0,0-7-2,7.638,7.638,0,0,0-5,2c-1,1-2,2-2,3s1,2,2,3,3,2,6,3q13.5,3,18,6c4,1,6,4,8,7a16.894,16.894,0,0,1,3,10c0,4-2,8-4,11-2,4-5,7-9,8q-6,3-15,3c-10,0-18-2-22-6C1719,459,1717,454,1716,447Z",
    fill: "#6b6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M224,57c-16,6-30,16-40,30-11,14-17,33-17,52,0,25,9,47,25,62a87.745,87.745,0,0,0,62,26c25,0,46-10,62-26,16-15,26-37,26-62a110.19,110.19,0,0,0-2-18c-1-5-2-9-4-13l-1,1v-2c-2,1-5,1-7,1-4,1-9,1-13,1q-30,0-54-15a95.622,95.622,0,0,1-35-37l-2,1ZM172,78a98.115,98.115,0,0,1,54-37l6-2v1h2l2,5a95.367,95.367,0,0,0,33,36c13,9,29,13,46,13h11c4-1,8-1,11-2l6-2v1h2l3,5a172.327,172.327,0,0,1,7,21,163.523,163.523,0,0,1,2,22c0,29-11,54-30,73s-44,30-73,30c-28,0-54-11-72-30-19-19-30-44-30-73C152,116,159,95,172,78Z",
    fill: "#fcc603",
    stroke: "#fcc603",
    strokeWidth: 4.486
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M455,313a86.323,86.323,0,0,0-17-46c-11-15-27-26-46-32a86.452,86.452,0,0,0-67,7c-19,11-35,29-42,52-7,24-4,47,7,67a87.662,87.662,0,0,0,52,42c6,2,13,3,19,4h12v-1l2-1a12.683,12.683,0,0,1,1-6,30.793,30.793,0,0,1,3-13,93.4,93.4,0,0,1,30-47,98.642,98.642,0,0,1,45-24v-1Zm-5-55a104.322,104.322,0,0,1,20,62v6l-1,1-1,1-6,1a87.024,87.024,0,0,0-43,21c-12,10-21,24-26,40-1,4-2,8-2,11-1,4-1,8-2,11v6h-1v2l-6,1c-7,1-15,1-22,1-7-1-15-2-22-4a102.155,102.155,0,0,1-61-50c-13-23-16-51-8-78s26-48,49-61,51-16,78-8C419,227,437,241,450,258Z",
    fill: "#6b6767",
    stroke: "#6b6767",
    strokeWidth: 4.486
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M53,326c0-22,7-44,20-61a102.6,102.6,0,0,1,53-38c27-8,55-4,78,8,23,13,42,34,50,62,8,27,4,55-8,78-13,23-34,41-61,49-8,2-15,4-22,4-8,1-15,0-22-1l-7-1v-1h-1v-6c0-4,0-8-1-11-1-4-1-8-2-11a93.076,93.076,0,0,0-26-41c-12-11-28-18-44-21l-6-1v-1H53Zm32-53a89.576,89.576,0,0,0-17,47h1v2a113.46,113.46,0,0,1,45,23c14,12,24,29,30,48l3,12c0,2,0,5,1,7h1v1a28.542,28.542,0,0,0,13,0,56.625,56.625,0,0,0,18-3,90.412,90.412,0,0,0,53-42,96.253,96.253,0,0,0,7-67c-7-23-23-42-43-52-19-11-43-14-67-7C112,247,96,259,85,273Z",
    fill: "#54b329",
    stroke: "#54b329",
    strokeWidth: 4.486
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJencioLogo);
export default __webpack_public_path__ + "static/media/jencio-logo.e164ea03b5c73d74fd4a7cc5b6e922bf.svg";
export { ForwardRef as ReactComponent };